'use client'
import { useRef, useEffect } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/all';


export default function InfiniteTextScroll() {

	const firstText = useRef(null);
	const secondText = useRef(null);
	const slider = useRef(null);
	let xPercent = 0;
	let direction = -1;

	useEffect( () => {
		gsap.registerPlugin(ScrollTrigger);
		gsap.to(slider.current, {
			scrollTrigger: {
				trigger: document.documentElement,
				scrub: 0.25,
				start: 0,
				end: window.innerHeight,
				onUpdate: e => direction = e.direction * -1
			},
			x: "-500px",
		})
		requestAnimationFrame(animate);
	}, [slider])

	const animate = () => {
		if(xPercent < -100){
			xPercent = 0;
		}
		else if(xPercent > 0){
			xPercent = -100;
		}
		gsap.set(firstText.current, {xPercent: xPercent})
		gsap.set(secondText.current, {xPercent: xPercent})
		requestAnimationFrame(animate);
		xPercent += 0.05 * direction;
	}

	return (
		<div className="infinite_text_scroll">
			<main className="main">
				<div className="sliderContainer">
					<div ref={slider} className="slider">

						<p ref={firstText}>
							People change - everything.
						</p>
						<p ref={secondText}>
							People change - everything.
						</p>
					</div>
				</div>
			</main>
		</div>
	)
}